import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { MembershipGroup } from 'src/features/memberships/types';
import type { ListDTO } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/';

interface DTO extends ListDTO {
    parkingId: string;
    membershipGroupId: number;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, membershipGroupId, ...params }: DTO): Promise<MembershipGroup> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipGroupId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => {
            const membershipGroup = await queryFn(payload);
            return membershipGroup;
        },
        ...config,
    });

export {
    RESOURCE as GET_MEMBERSHIP_GROUPS_RESOURCE,
    queryFn as getMembershipGroup,
    useQueryHook as useGetMembershipGroup,
};
export type { DTO as GetMembershipGroupDTO };
